import { useCallback } from 'react';
import { useIdleCallback } from '@shopify/react-idle';
import { handleError } from '@/lib/handleError';
import { getCategoryTreeBySlug } from '@fh-components/fh-js-api-core/store/slices/categoriesSlice';
import { TextPage } from '@/layouts';
import ecommerce from '@/seo/Ecommerce';

const NextNewsItemPage = props => {
	const setPageType = useCallback(() => {
		ecommerce.setPageType(ecommerce.PAGE_TYPES.SPECIAL);
	}, []);

	useIdleCallback(setPageType);

	return <TextPage {...props} />;
};

NextNewsItemPage.getInitialProps = async ({ query, reduxStore }) => {
	const { slug, access } = query;
	let data;
	let textPageType = 'special_offer';
	let redirectTo = null;

	await reduxStore.dispatch(
		getCategoryTreeBySlug({
			slug: `/${slug}`,
			onSuccess: result => {
				if (result.page.pageType === 'redirect') {
					textPageType = 'redirect';
					redirectTo = result.page.data.to;
				}
				data = result.page.data.page;
			},
			onError: result => {
				handleError(result);
			},
		}),
	);

	return { slug, textPageType, access, data, redirectTo };
};

export default NextNewsItemPage;
